<template>
  <div class="text-side-menu">
    
    <div class="left-align left">
      <span class="heading">Enter text here</span>
    </div>
    <div class="vspace-2"></div> 
    <at-textarea v-model="textValue" class="left right" min-rows="2" max-rows="10" placeholder="Enter text here..."></at-textarea>
    
    <div class="vspace-2"></div>
    <div class="vspace"></div>
      
    <div>
      <div class="left-align left">
        <span class="heading">Fonts</span>
      </div>
      <div class="vspace-2"></div> 
      
      <div v-for="font in fonts" v-bind:key="font.name" class="font-item left-align" @click="addText(font.name)">
        <div style="padding:10px">
          <div class="fontd-name" style="font-size:10px">
          {{font.name}}
          </div>
          
          <div style="font-size:22px" v-bind:id="font.name">  
              {{textValue}}
          </div>
          
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { BezieApp } from '../../lib/bezieLib/BezieApp';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';

export default {
  name: 'TextSideMenu',
  props: {
    bezieAppObj : BezieApp
  },
  data: function(){
    return {
      textValue: 'Hello World!',
      fonts: [
        {
          'name':'Permanent Marker',
          'src':'https://fonts.gstatic.com/s/permanentmarker/v9/Fh4uPib9Iyv2ucM6pGQMWimMp004La2Cf5b6jlg.woff2'
        },
        {
          'name':'Dancing Script',
          'src':'https://fonts.gstatic.com/s/dancingscript/v13/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BMSo3Sup6hNX6plRP.woff'
        },
        {
          'name':'Amatic SC',
          'src':'https://fonts.gstatic.com/s/amaticsc/v13/TUZyzwprpvBS1izr_vOECuSfU5cP1Q.woff2'
        },
        {
          'name':'Caveat',
          'src':'https://fonts.gstatic.com/s/caveat/v7/Wnz6HAc5bAfYB2Q7ZjYYiAzcPA.woff2'
        },
        {
          'name':'Fondamento',
          'src':'https://fonts.gstatic.com/s/fondamento/v10/4UaHrEJGsxNmFTPDnkaJ96rp57F2IwM.woff2'
        },
        {
          'name':'Mark Script',
          'src':'https://fonts.gstatic.com/s/marckscript/v10/nwpTtK2oNgBA3Or78gapdwuyyCg_SsDV7A.woff2'
        },
        {
          'name':'Comfortaa',
          'src':'https://fonts.gstatic.com/s/comfortaa/v27/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMDrMfJh1Zyc61YA.woff'
        },
        {
          'name':'Cutive Mono',
          'src':'https://fonts.gstatic.com/s/cutivemono/v8/m8JWjfRfY7WVjVi2E-K9H6RCTm6o39uc.woff2'
        },
        {
          'name':'Dosis',
          'src':'https://fonts.gstatic.com/s/dosis/v16/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7Ml2xMCbKsUPqjm.woff'
        },
        {
          'name':'Lobster',
          'src':'https://fonts.gstatic.com/s/lobster/v22/neILzCirqoswsqX9zoKmM4MwWJU.woff2'
        },
        {
          'name':'Major Mono Display',
          'src':'https://fonts.gstatic.com/s/majormonodisplay/v4/RWmVoLyb5fEqtsfBX9PDZIGr2tFubRh7DXeRAHRfwg.woff2'
        },
        {
          'name':'Monoton',
          'src':'https://fonts.gstatic.com/s/monoton/v9/5h1aiZUrOngCibe4TkHLQka4BU4.woff2'
        },
        {
          'name':'Open Sans',
          'src':'https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2'
        },
        {
          'name':'Playball',
          'src':'https://fonts.gstatic.com/s/playball/v9/TK3gWksYAxQ7jbsKcg8EneptKZ2s.woff2'
        },
        {
          'name':'Poiret One',
          'src':'https://fonts.gstatic.com/s/poiretone/v8/UqyVK80NJXN4zfRgbdfbo55cV-UyZKA.woff2'
        },
        {
          'name':'Roboto Slab',
          'src':'https://fonts.gstatic.com/s/robotoslab/v10/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISmb2RlV9Su1cai.woff'
        },
        {
          'name':'Special Elite',
          'src':'https://fonts.gstatic.com/s/specialelite/v10/XLYgIZbkc4JPUL5CVArUVL0ntnAOSFNuQsI.woff2'
        },
        {
          'name':'VT323',
          'src':'https://fonts.gstatic.com/s/vt323/v11/pxiKyp0ihIEF2isfFJXUdVNF.woff2'
        }   
      ]
    }
  },
  methods:{
    addText(fontname){
      if(this.bezieAppObj){
        UIEvents.addTextToCanvas(this.textValue, fontname);
      } else {
        console.log("Bezie App obj not init.")
        this.$Notify({
          title: 'Initialization error',
          message: 'Kindly reload app',
          type: 'error'
        });
      }
    },
    loadFont(name, src){
      let f = new FontFace(name, "url("+src+")");
      //console.log("loading: "+name+" ::"+'"'+name+'", Arial');
      f.load().then(function(loaded_face) {
        document.fonts.add(loaded_face);
        if(document.getElementById(name)!=undefined){
          document.getElementById(name).style.fontFamily = '"'+name+'", Arial';
          //console.log("set "+name);
        }
        //console.log("Done");
      }).catch(function(error) {
        console.log("Error loading font "+name+": "+error);
		  });
    }
  },
  mounted: function(){
    var font;
    for( font of this.fonts){
      this.loadFont(font.name, font.src);
    }
  }
}
</script>

<style scoped>
.font-item{
  margin: 5px 5px 5px 5px;
  background-color: whitesmoke;
  border-radius: 5px;
  cursor: pointer;
}
.font-item:hover {
  background-color: #e5e5e6;
}
.font-name{
  text-align: right;
  width: 100%;
  color: gray;
}
</style>